import produce from 'immer';

// TYPES
import { Types, ConsultarInapto } from './types';
import { ReducerAction } from '../../../../types';

export const INITIAL_STATE: ConsultarInapto = {
	status: 0,
	data: null,
};

export default function consultarInaptoReducer(
	state = INITIAL_STATE,
	action: ReducerAction,
): ConsultarInapto {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTAR_INAPTO_REQUEST: {
				draft.status = 100;
				break;
			}
			case Types.CONSULTAR_INAPTO_SUCCESS: {
				draft.data = action.payload.data;
				draft.status = action.payload.status;
				break;
			}
			case Types.CONSULTAR_INAPTO_FAILURE: {
				draft.status = 400;
				break;
			}
			case Types.CONSULTAR_INAPTO_CLEAR: {
				draft.data = INITIAL_STATE.data;
				draft.status = INITIAL_STATE.status;
				break;
			}
			default:
		}
	});
}
